import { Component, inject } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { WindowRef } from '@boels/helpers';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'boels-back-to-top',
  imports: [
    NgSelectModule,
    FormsModule,
    FontAwesomeModule,
    TranslocoModule,
    ButtonComponent,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['productList'],
    },
  ],
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.scss'],
})
export class BackToTopComponent {
  private winRef = inject(WindowRef);

  faArrowUp = faArrowUp;

  backToTop(): void {
    this.winRef.nativeWindow?.scroll(0, 0);
  }
}
